import React, { createContext, useState } from 'react';

export const CouponsContext = createContext();

export const CouponsProvider = ({ children }) => {
  const [coupons, setCoupons] = useState([]);
  const [totalPages, setTotalPages] = useState()

  return (
    <CouponsContext.Provider value={{ coupons, setCoupons, totalPages, setTotalPages }}>
      {children}
    </CouponsContext.Provider>
  );
};